import BigNumber from "bignumber.js";
export default {
    methods: {
        decimalValue(val, decimal) {
            const value = new BigNumber(val)
            return  value.toFixed(decimal) * 1
        }
    }
}
